export default {
  about: {
    ceo: {
      eyebrow: 'Leadership',
      title: 'CEO Message',
      heading: 'Your Fast and Reliable Partner in Global Chemical Trade',
      p1: "Thank you for visiting Daishin Corporation's website.\nDaishin is a specialized trading company supporting the global movement of chemicals and rare metals.",
      p2: 'We help international partners source from Japan efficiently, manage cross-border transactions smoothly, and respond quickly to changing needs. We mitigate risk through strong coordination, financing capabilities, and reliable communication.',
      p3: 'Our role is not simply to trade products, but to ensure stable supply, speed, and long-term partnerships in an increasingly complex global market.',
      closing: 'We look forward to working with you.',
      name: 'Masa Oguchi, CEO',
    },
    profile: {
      eyebrow: 'Company Details',
      title: 'Company Profile',
      items: [
        { label: 'Company Name', value: 'Daishin Corporation' },
        { label: 'Date of Establishment', value: 'June 2004' },
        { label: 'Capital', value: 'JPY 50 million' },
        { label: 'Annual Sales', value: 'JPY 1 billion' },
        { label: 'Representative', value: 'Masa Oguchi, CEO' },
        { label: 'Primary Business', value: 'Global trading of chemicals and minor metals, and related businesses' },
        { label: 'Address', value: '3-8-7, Minamisemba, Chuo-ku, Osaka 542-0081, Japan' },
      ],
    },
    history: {
      eyebrow: 'Our Journey',
      title: 'History',
      items: [
        { date: 'Jun 2004', event: 'Established in Amagasaki, Hyogo Prefecture' },
        { date: 'Sep 2024', event: 'Registered as a General Seller of Poisonous and Deleterious Substances', pdfLink: '/docs/poison_for_sale.pdf' },
        { date: 'Oct 2024', event: 'Registered as a Poisonous and Deleterious Substances Importer', pdfLink: '/docs/import_poison.pdf' },
        { date: 'Dec 2024', event: 'Obtained Certificate of Acceptance for Notification of Business as an Exporter of Narcotic Raw Materials', pdfLink: '/docs/raw_material_exports.pdf' },
        { date: 'Dec 2024', event: 'Obtained Certificate of Acceptance for Notification of Business as an Importer of Narcotic Raw Materials', pdfLink: '/docs/import_edraw_materials.pdf' },
        { date: 'Dec 2014', event: 'Relocated to Kita-ku, Osaka City' },
        { date: 'Jun 2023', event: 'Relocated to Chuo-ku, Osaka City' },
      ],
    },
    access: {
      eyebrow: 'Visit Us',
      title: 'Access',
      addressTitle: 'Address',
      address: '3-8-7 Minamisemba, Chuo-ku\nOsaka 542-0081, Japan',
      phone: 'Phone: +81-6-6371-3730',
      hoursTitle: 'Business Hours',
      hours: 'Monday–Friday: 09:00–18:00\n(Closed on Saturdays, Sundays, and National Holidays)',
      stationsTitle: 'Nearest Stations',
      stations: [
        '4-minute walk from Exit 1, Shinsaibashi Station (Osaka Metro)',
        '8-minute walk from North Exit 7, Nagahoribashi Station (Osaka Metro)',
        '10-minute walk from Exit 12, Hommachi Station (Osaka Metro)',
      ],
    },
    mapTitle: 'Daishin Corporation Office Location',
  },
};
